import { useCallback } from 'react'

import { observeIntersection, unobserveIntersection } from '@/utils/observerUtil'

type Props = {
  minTime?: number
  onImpression: () => void
}

export const useImpression = ({ minTime = 1000, onImpression }: Props) =>
  useCallback(
    (node: HTMLElement | null) => {
      if (!node) return

      let timeout: ReturnType<typeof setTimeout> | undefined

      const cancel = () => {
        clearTimeout(timeout)
        timeout = undefined
      }

      const unobserve = () => {
        cancel()
        unobserveIntersection('halfInView', node)
      }

      observeIntersection('halfInView', node, (entry) => {
        if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return cancel()
        timeout ??= setTimeout(() => {
          unobserve()
          onImpression()
        }, minTime)
      })

      return unobserve
    },
    [onImpression, minTime],
  )
